import { useEffect, useState, useCallback } from "react";

import "./Checkbox.css";

export default function Checkbox({ allCheck, id, setDeleteProducts }) {
  const [state, setState] = useState(false);

  const handleClick = useCallback(() => {
    setState((prev) => {
      const newState = !prev;
      // Update deleteProducts based on new state
      setDeleteProducts((currentProducts) => {
        if (newState && !currentProducts.includes(id)) {
          return [...currentProducts, id];
        } else if (!newState) {
          return currentProducts.filter((productId) => productId !== id);
        }
        return currentProducts;
      });
      return newState;
    });
  }, [id, setDeleteProducts]);

  // Sync with allCheck from parent
  useEffect(() => {
    setState(allCheck);
  }, [allCheck]);

  return (
    <label className="cont">
      <input className="checkbox" type="checkbox" checked={state} onChange={handleClick} />
      <span className="checkbox-span"></span>
    </label>
  );
}
